export type PlanType =
  | "basic"
  | "pro"
  | "pro-plus"
  | "metered-api"
  | "basic-yearly"
  | "pro-yearly"
  | "pro-plus-yearly";

export const PLAN_TO_PRICE: Map<PlanType, number> = new Map([
  ["basic", 29],
  ["basic-yearly", 278.4],
  ["pro", 79],
  ["pro-yearly", 758.4],
  ["pro-plus", 189],
  ["pro-plus-yearly", 1814.4],
]);

export const PLAN_TO_PRICE_ID: Map<PlanType, string[]> = new Map([
  ["basic", ["price_1NE6U6J9Xk7InalcxtfMQYI1"]],
  [
    "basic-yearly",
    ["price_1OPS6yJ9Xk7InalcM1VUGosL", "price_1NNbDaJ9Xk7InalcLnKalXjh"],
  ],
  // Second Pro entry: the $59 price (PRO_59_PRICE_IDS in
  // helpers/proPriceExperiment.ts).
  ["pro", ["price_1NIx0DJ9Xk7InalcX7rHppUr", "price_1UNC9cJ9Xk7InalcvPR6ZqKs"]],
  // Second entry of each yearly plan: the discounted price used by checkout
  // (PLAN_TO_PRICE_ID_FOR_YEARLY_DISCOUNT in klap-api's billingConst.ts).
  // Pro yearly's third to fifth entries: the $59 checkout, switch and
  // Checkout-upsell prices.
  [
    "pro-yearly",
    [
      "price_1OPSHMJ9Xk7InalcPouoFx7U",
      "price_1NNbFSJ9Xk7InalcCbU3utOK",
      "price_1UNC9dJ9Xk7Inalc5urU7h9t",
      "price_1UNC9dJ9Xk7Inalct4Nn4cvL",
      "price_1UNCWQJ9Xk7Inalc13w2O3aa",
    ],
  ],
  ["pro-plus", ["price_1OPXdcJ9Xk7Inalco1IINBFn"]],
  [
    "pro-plus-yearly",
    ["price_1OPXroJ9Xk7InalcvNH1dqAV", "price_1S0NvfJ9Xk7InalcLRzJiYb6"],
  ],
  [
    "metered-api",
    [
      "price_1Q5Q3AJ9Xk7InalcsZNX6y5O",
      "price_1Q5Q3AJ9Xk7InalcqFNHxFKW",
      "price_1Q5Q3AJ9Xk7Inalce2EV1IeF",
    ],
  ],
]);

export const PRICE_ID_TO_PLAN: Map<string, PlanType> = new Map(
  Array.from(PLAN_TO_PRICE_ID.entries()).flatMap(([plan, prices]) =>
    prices.map((price) => [price, plan])
  )
);

export const PLAN_TO_VIDEO_COUNT_LIMIT: Map<PlanType, number> = new Map([
  ["basic", 5],
  ["pro", 15],
  ["pro-plus", 45],
  ["basic-yearly", 60],
  ["pro-yearly", 180],
  ["pro-plus-yearly", 540],
]);

export const PLAN_TO_CLIP_COUNT_LIMIT: Map<PlanType, number> = new Map([
  ["basic", 100],
  ["pro", 300],
  ["pro-plus", 1000],
  ["basic-yearly", 1200],
  ["pro-yearly", 3600],
  ["pro-plus-yearly", 12000],
]);

// 1 unit = 1 upload minute. Yearly plans get 12x the monthly amount.
export const PLAN_TO_CREDIT_COUNT: Map<PlanType, number> = new Map([
  ["basic", 300],
  ["pro", 900],
  ["pro-plus", 2700],
  ["basic-yearly", 3600],
  ["pro-yearly", 10800],
  ["pro-plus-yearly", 27000],
]);

// Unique clips exported/downloaded/published (deduped by project id).
export const PLAN_TO_EXPORT_COUNT_LIMIT: Map<PlanType, number> = new Map([
  ["basic", 15],
  ["pro", 35],
  ["pro-plus", 100],
  ["basic-yearly", 180],
  ["pro-yearly", 420],
  ["pro-plus-yearly", 1200],
]);

export const PLAN_TO_EXPORT_EYEBROW: Map<PlanType, string> = new Map([
  ["basic", "Post 3x a week"],
  ["pro", "Post every day"],
  ["pro-plus", "Post 3x a day"],
  ["basic-yearly", "Post 3x a week"],
  ["pro-yearly", "Post every day"],
  ["pro-plus-yearly", "Post 3x a day"],
]);

export const PLAN_TO_AUDIENCE_EYEBROW: Map<PlanType, string> = new Map([
  ["basic", "For individuals"],
  ["pro", "For professionals"],
  ["pro-plus", "For teams"],
  ["basic-yearly", "For individuals"],
  ["pro-yearly", "For professionals"],
  ["pro-plus-yearly", "For teams"],
]);

export const PLAN_TO_EXPORT_SPEC: Map<PlanType, string> = new Map([
  ["basic", "15 exports/mo"],
  ["pro", "35 exports/mo"],
  ["pro-plus", "100 exports/mo"],
  ["basic-yearly", "15 exports/mo"],
  ["pro-yearly", "35 exports/mo"],
  ["pro-plus-yearly", "100 exports/mo"],
]);

// Max accepted source-video length, identical on every paid plan (upgrading
// never lifts it). Mirrors UPLOAD_DURATION_ALLOWANCE_SECONDS in klap-api's
// billingConst.ts.
export const UPLOAD_DURATION_ALLOWANCE_SECONDS = 3 * 60 * 60;

export const PLAN_TO_LABEL: Map<PlanType, string> = new Map([
  ["basic", "Basic"],
  ["pro", "Pro"],
  ["pro-plus", "Pro+"],
  ["basic-yearly", "Basic"],
  ["pro-yearly", "Pro"],
  ["pro-plus-yearly", "Pro+"],
  ["metered-api", "API"],
]);
